import { NavLink, Outlet } from 'react-router-dom';
import { faChartLine, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Configuration.scss';
import { useTranslation } from 'react-i18next';

function Configuration() {
  const { t } = useTranslation();

  return (
    <>
      <div className="navbar">
        <div className="nav">
          <NavLink
            to="/configuration/users"
            className={({ isActive }) => (isActive ? 'active-tab nav-item pointer' : 'nav-item pointer')}
          >
            <FontAwesomeIcon className="nav-icon" icon={faUser} />
            { t('Configuration.userManagement') }
          </NavLink>

          <NavLink
            to="/configuration/instances"
            className={({ isActive }) => (isActive ? 'active-tab nav-item pointer' : 'nav-item pointer')}
          >
            <FontAwesomeIcon className="nav-icon" icon={faUser} />
            { t('Configuration.instanceManagement') }
          </NavLink>

          <NavLink
            to="/"
            className="nav-item pointer"
            style={{ position: 'absolute', right: '20px' }}
          >
            <FontAwesomeIcon className="nav-icon" icon={faChartLine} />
            { t('Configuration.back') }
          </NavLink>
        </div>
      </div>

      <Outlet />
    </>
  );
}

export default Configuration;
